import { styled } from 'styled-components';
import { Card } from 'antd';

export const ContentCard = styled(Card)`
  max-width: 1200px;
  margin: 0 auto;
`;

export const HonbuSwitch = styled.div`
  margin-bottom: 16px;
`;

export const ApplicationTable = styled.div`
  width: 100%;
`;

export const StyledRow = styled.article`
  display: grid;
  grid-template-columns: 80px 120px 160px 120px 120px 140px 100px 140px;
  gap: 16px;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #d9d9d9;
  background: #fff;

  &:first-child {
    border-radius: 8px 8px 0 0;
    font-weight: bold;
    background: #fafafa;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:not(:first-child):hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &:not(:last-child) {
    border-bottom: none;
  }
`;

export const Cell = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyCell = styled(Cell)`
  grid-column: 1 / -1;
  text-align: center;
  padding: 24px;
`;
